export default "__VITE_ASSET__ByliV8Gp__"